export default __webpack_public_path__ + "static/media/logo_maximus_solucoes.006db0d1.png";